module.exports = __webpack_public_path__ + "static/media/c-sharp-expert.d9fd8046.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/c-sharp-expert.png
// module id = 1453
// module chunks = 146